import React from "react";
import { arrayMoveImmutable } from "array-move";
import { GeneralFeatureCompetitionsTable } from "./generalTable";
import dataProvider from "../../../providers/dataProvider";

export interface GeneralFeaturedCompetitions {
  title: string;
  competitionType: string;
  _id: string;
  order: string;
}

export const GeneralTabFeaturedCompetitions = ({
  competitions,
  setGeneralCompetitions,
}) => {
  const sendCompetitionsOrderToServer = async (
    competitions: Array<GeneralFeaturedCompetitions>
  ) => {
    const arr: Array<{ _id: string; order: string }> = [];
    for (let i = 0; i < competitions.length; i++) {
      const { _id, order } = competitions[i];
      arr.push({ _id: _id, order: "" + order });
    }
    dataProvider.setFeaturedCompetitionsOrder(arr);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setGeneralCompetitions(() =>
      arrayMoveImmutable(competitions, oldIndex, newIndex)
    );
    sendCompetitionsOrderToServer(
      arrayMoveImmutable(competitions, oldIndex, newIndex)
    );
  };

  return (
    <GeneralFeatureCompetitionsTable
      competitionsArr={competitions}
      handleSortEnd={onSortEnd}
    />
  );
};
